import { BusinessUnit } from '@core/entities/businessUnit'
import { Entity } from '@core/entities/entity'
import {
  IProjectSummary,
  ProjectPermission,
  ProjectStatus,
} from '@core/entities/project'
import { plainToInstance } from 'class-transformer'

export class ProjectSummary extends Entity<IProjectSummary> {
  organisationId: number
  id: number
  name: string
  code: string
  description: string
  startDate: string
  endDate: string
  status: ProjectStatus
  businessUnits: BusinessUnit[]
  permittedActions?: ProjectPermission[]

  public static new(payload: unknown): ProjectSummary {
    const entity = plainToInstance(ProjectSummary, payload)

    return entity
  }

  public hasPermission(permission: ProjectPermission): boolean {
    return this.permittedActions?.includes(permission)
  }

  public canEdit(): boolean {
    return this.hasPermission('EDIT')
  }

  public canCreatePermits(): boolean {
    return this.hasPermission('CREATE_PERMITS')
  }
}
